import { HardwareOptionType, HardwareRentPageValueType } from '@/types/fitting-hardware';

import {
  SET_HARDWARE_OPTIONS,
  SET_SELECTED_HARDWARE_OPTION,
  SET_PAGE_VALUE,
  SET_HARDWARE_SELECTION_HINT,
  SET_HARDWARE_SELECTION_ENABLED,
  SET_ACCESS_TYPE,
  REMOVE_SELECTED_HARDWARE_OPTION,
  SET_NEW_SELECTED_HARDWARE_OPTION,
} from '@/redux/fitting-hardware/action-types';

export const setPageValue = (pageValue : HardwareRentPageValueType) => ({
  type: SET_PAGE_VALUE,
  value: pageValue,
});

export const setHardwareSelectionEnabled = (hardwareSelectionEnabled : boolean) => ({
  type: SET_HARDWARE_SELECTION_ENABLED,
  value: hardwareSelectionEnabled,
});

export const setAccessType = (accessType : string) => ({
  type: SET_ACCESS_TYPE,
  value: accessType,
});

export const removeSelectedHardwareOption = (index : number) => ({
  type: REMOVE_SELECTED_HARDWARE_OPTION,
  value: index,
});

export const setHardwareOptions = (hardwareOptions : HardwareOptionType[]) => ({
  type: SET_HARDWARE_OPTIONS,
  value: hardwareOptions,
});

export const setSelectedHardwareOption = (index : number) => ({
  type: SET_SELECTED_HARDWARE_OPTION,
  value: index,
});

export const setNewSelectedHardwareOption = (index : number) => ({
  type: SET_NEW_SELECTED_HARDWARE_OPTION,
  value: index,
});

export const setHardwareSelectionHint = (hardwareSelectionHint : string) => ({
  type: SET_HARDWARE_SELECTION_HINT,
  value: hardwareSelectionHint,
});
